import {
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  LOGOUT,
  GET_CURRENT_USER_REQUEST,
  GET_CURRENT_USER_SUCCESS,
  GET_CURRENT_USER_FAILURE,
} from './Auth.constant';
import { IAuthState, AuthActionsTypes } from './Auth.type';

const getInitialState = (): IAuthState => {
  const token = localStorage.getItem('access_token');
  return {
    user: null,
    token: token,
    loading: false,
    error: null,
    isAuthenticated: !!token,
  };
};

const initialState: IAuthState = getInitialState();

export default function authReducer(
  state = initialState,
  action: AuthActionsTypes,
): IAuthState {
  switch (action.type) {
    case LOGIN_REQUEST:
    case GET_CURRENT_USER_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case LOGIN_SUCCESS:
      return {
        ...state,
        token: action.payload.token,
        loading: false,
        error: null,
        isAuthenticated: true,
      };

    case LOGIN_FAILURE:
    case GET_CURRENT_USER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        isAuthenticated: false,
        token: null,
        user: null,
      };

    case GET_CURRENT_USER_SUCCESS:
      return {
        ...state,
        user: action.payload,
        loading: false,
        error: null,
      };

    case LOGOUT:
      localStorage.removeItem('access_token');
      return {
        ...state,
        user: null,
        token: null,
        isAuthenticated: false,
        error: null,
      };

    default:
      return state;
  }
}
